/**
 * Curated game definitions for the web build.
 *
 * The bundled adaptor_bridge core extension registers a game for every
 * adaptor entry that provides an info service and carries pre-fetched
 * gameInfo. Entries here declare ONLY the info service, so the bridge
 * never calls back into adaptors.call/buildSnapshot (those remain fused
 * off) — games register with no file-based discovery requirements and a
 * "." mod path, which is exactly what the manual folder-selection flow
 * needs.
 *
 * gameInfo must be in the normalized array form the bridge reads
 * (info.steam?.[0]?.appId etc). nexusMods[0].domain drives the Nexus page
 * association and thumbnail lookup in the game picker.
 */
function entry(id, gameInfo) {
    return {
        name: id,
        pid: "web",
        requires: [],
        provides: [`vortex:adaptor/${id}/info`],
        gameInfo,
    };
}
export const WEB_GAMES = [
    entry("stardewvalley", {
        gameUri: "game:stardewvalley",
        displayName: "Stardew Valley",
        steam: [{ appId: 413150 }],
        gog: [{ gameId: 1453375253 }],
        nexusMods: [{ domain: "stardewvalley" }],
    }),
    entry("cyberpunk2077", {
        gameUri: "game:cyberpunk2077",
        displayName: "Cyberpunk 2077",
        steam: [{ appId: 1091500 }],
        gog: [{ gameId: 1423049311 }],
        epic: [{ catalogNamespace: "77f2b98e2cef40c8a7437518bf420e47" }],
        nexusMods: [{ domain: "cyberpunk2077" }],
    }),
    entry("skyrimspecialedition", {
        gameUri: "game:skyrimspecialedition",
        displayName: "The Elder Scrolls V: Skyrim Special Edition",
        steam: [{ appId: 489830 }],
        nexusMods: [{ domain: "skyrimspecialedition" }],
    }),
    entry("fallout4", {
        gameUri: "game:fallout4",
        displayName: "Fallout 4",
        steam: [{ appId: 377160 }],
        nexusMods: [{ domain: "fallout4" }],
    }),
    entry("witcher3", {
        gameUri: "game:witcher3",
        displayName: "The Witcher 3: Wild Hunt",
        steam: [{ appId: 292030 }],
        gog: [{ gameId: 1207664663 }],
        nexusMods: [{ domain: "witcher3" }],
    }),
    entry("baldursgate3", {
        gameUri: "game:baldursgate3",
        displayName: "Baldur's Gate 3",
        steam: [{ appId: 1086940 }],
        gog: [{ gameId: 1456460669 }],
        nexusMods: [{ domain: "baldursgate3" }],
    }),
    entry("valheim", {
        gameUri: "game:valheim",
        displayName: "Valheim",
        steam: [{ appId: 892970 }],
        nexusMods: [{ domain: "valheim" }],
    }),
];
